import isNumber from 'utils/number/isNumber'
import storage from 'proxy-storage'

function getRange({ values }, paramURL): FilterRange {
  const result: FilterRange = {
    min: undefined,
    max: undefined
  }

  if (paramURL) {
    const [item_1, item_2] = paramURL.split(',')
    const min = +item_1
    const max = +item_2

    if (isNumber(min) && min >= values.min && min <= values.max) {
      result.min = min
    }

    if (isNumber(max) && max >= values.min && max <= values.max) {
      result.max = max
    }
  }

  return result
}

function getOne({ values }, paramURL) {
  return values.find(id => id === paramURL)
}

function getPrice({ values }, data = '') {
  const [item_1, item_2] = data.split(',')
  const min = +item_1
  const max = +item_2

  if (!isNumber(min) || !isNumber(max)) {
    return []
  }

  let minIndex = 0
  for (; minIndex < values.length; minIndex++) {
    const range = values[minIndex]
    if (min <= range.min) {
      break
    }
  }

  let maxIndex = 0
  for (; maxIndex < values.length; maxIndex++) {
    const range = values[maxIndex]
    if (max <= range.max) {
      break
    }
  }

  const result = values.slice(minIndex, maxIndex + 1)

  return result
}

function getMultiple({ values }, data = '') {
  return data.split(',').filter(id => values.includes(id.toLowerCase()))
}

function getFiltersFromURL(URLParams, options: FilterOptions) {
  const hcStorage = storage.getItem('hc')
  const hcPeriod = +hcStorage.period
  const defaultPeriod =
    options.period.values.find(option => option === hcPeriod) ||
    options.period.values[options.period.values.length - 1]

  const period = getOne(options.period, +URLParams.period)
  const urlPolicies = +URLParams.policies

  const policies =
    defaultPeriod && options.period.policies[defaultPeriod][urlPolicies]
      ? urlPolicies
      : undefined

  return {
    defaultPeriod,
    filters: {
      benefits: getMultiple(options.benefits, URLParams.benefits),
      type: getMultiple(options.type, URLParams.type),
      price: getPrice(options.price, URLParams.price),
      period,
      policies,
      coverage: getRange(options.coverage, URLParams.coverage),
      networkProvider: getMultiple(options.networkProvider, URLParams.network_provider),
      deductible: getRange(options.deductible, URLParams.deductible),
      coinsurance: getMultiple(options.coinsurance, URLParams.coinsurance),
      moop: getMultiple(options.moop, URLParams.moop),
      drug: getMultiple(options.drug, URLParams.prescription_drug)
    }
  }
}

export default getFiltersFromURL
